<fd-flexible-column-layout [(layout)]="localLayout" (layoutChange)="onLayoutChange()">
    <ng-template #startColumn>
        <div class="table-scroll main-table">
            <div class="advanced-search-container" *ngIf="!!advancedSearchOpen">
                <app-advanced-search
                        [currentOrg]="''"
                        [currentPath]="''"
                        [fullPath]="''"
                        [availableResourceTypes]="availableResourceTypes"
                        [resultCount]="items.length"
                        [loadSavedFilters]="advancedSearchTerms"
                        [currentViewName]="currentFilterViewName"
                        [isFclOpen]="localLayout === 'OneColumnStartFullScreen'"
                        (close)="advancedSearchToggled.emit(false)"
                        (viewSaved)="viewSaved.emit($event)"
                        (applyFilters)="onApplyAdvancedFilters($event)"
                        (clearContent)="onClearContent()"
                        (cancelSearch)="onCancelSearch()"
                        (filtersModified)="filtersChanged.emit()">
                </app-advanced-search>
            </div>

            <app-data-table #dataTable
                            [tableKey]="currentTableKey"
                            [isClientSideSortingEnabled]="!isPaginatedView || advancedSearchOpen"
                            [persistSort]="true"
                            [persistFilters]="true"
                            persistFiltersAdditionalData="/"
                            persistSortAdditionalData="/"
                            class="resource-table"
                            [loading]="loading"
                            (rowClick)="selectRow($event, false)"
                            [clickable]="true"
                            [displayedColumns]="displayedColumns"
                            [selectedRow]="selectedRow"
                            [dataset]="items"
                            [stickyHeaders]="true"
                            [virtualScrollingEnabled]="true"
                            (sortChange)="onSortChange($event)"
                            (scrolledIndexChange)="this.scrollSubject.next()"
                            [noDataFilteredMessage]="noDataMessageFiltered"
                            [displayLoadingText]="displayLoadingText"
                            [filterPipe]="filterPipe"
                            [filterPipeArgs]="[searchTerm]"
                            sortProperty="displayName">
                <ng-template #noDataMessageTemplate>
                    <div [innerHTML]="getNoDataMessage()"></div>
                </ng-template>
                <app-column width="500px" [isSortable]="true" value="displayName"
                            header="Resource" title="Resource">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div class="link-wrapper">
                            <div class="link-title-wrapper">
                                <button fd-button
                                        fdType="transparent"
                                        class="margin-right-sm custom-icon"
                                        [routerLink]="[row.name]">
                                    <app-icon [icon]="row.type | resourceGlyph" size="lg"></app-icon>
                                </button>
                                <a fd-link aria-label="Standard"
                                   class="resource-title"
                                   [title]="'Display Name: ' + row.displayName"
                                   [routerLink]="[row.name]"
                                   (click)="selectResource($event)"
                                   queryParamsHandling="preserve">{{row.displayName}}</a>
                            </div>
                            <div class="buttons-wrapper" (click)="$event.stopPropagation()">
                                <div [ngClass]="{'buttons-container': true, 'show-buttons': this.showButtons(row)}">
                                    <ng-container>
                                        <button fd-button id='refresh-main-actions-btn' class="custom-icon"
                                                (click)="onReloadResource(row)"
                                                [fdCompact]="true" [fdType]="'transparent'" title="Refresh"
                                                i18n-title="XTOL|Tooltip of the Refresh button@@tableRefreshButtonTooltip">
                                            <app-icon icon="rotate-right" size="lg"></app-icon>
                                        </button>
                                        <button fd-button id='edit-main-actions-btn' class="custom-icon"
                                                *ngIf="isEditable(row)"
                                                (click)="onEditInline(row)"
                                                [fdCompact]="true" [fdType]="'transparent'"
                                                [title]="showResourceTitleText(row)"
                                                i18n-title="XTOL|Tooltip of the Edit button@@tableExportButtonTooltip">
                                            <app-icon *ngIf="showEditWithYaml(row); else editWithForm" [icon]="[$any('workspace'), $any('editYaml')]" size="lg" [fixedWidth]="true"></app-icon>
                                            <ng-template #editWithForm>
                                                <app-icon icon="pen" size="lg"></app-icon>
                                            </ng-template>
                                        </button>
                                        <app-organization-actions id="actions-menu"
                                                [busy]="policiesLoading"
                                                [resource]="row"
                                                [isFclClosed]="isFclClosed()"
                                                [advancedSearchOpen]="advancedSearchOpen"
                                                (editOrganization)="onEditOrganization(row)"
                                                (editWithForm)="onEditWithForm(row)"
                                                (editWithYAML)="onEditResource(row)"
                                                (isOpen)="setIsActionSheetOpen($event)"
                                                (openDetails)="openDetails(row)"
                                                (openPolicies)="openPolicies(row)"
                                                (openReferences)="openReferences(row)"
                                                (openEvents)="openEvents(row)"
                                                (openRTDResources)="openRTDResources(row)"
                                                (import)="onImport($event)"
                                                (delete)="onDeleteResource(row)"
                                                (reconcileResource)="onReconcileResource(row)"
                                                (reloadResource)="onReloadResource(row)"
                                                (moveResource)="onMoveResource(row)"
                                                (analyzeFailure)="onAnalyzeFailure(row)"
                                        ></app-organization-actions>
                                        <button fd-button (click)="toggleFcl(row)"
                                                class="toggle-row custom-icon"
                                                [fdCompact]="true" fdType="transparent"
                                                [title]="isFclClosed() ? 'View Details' : 'Hide Details'">
                                            <app-icon icon="angle-right" size="lg"></app-icon>
                                        </button>
                                    </ng-container>
                                </div>

                            </div>
                        </div>
                    </ng-template>
                </app-column>
                <app-column value="type" header="Type" width="200px"></app-column>
                <app-column value="description" width="250px" header="Description"></app-column>
                <app-column value="status" header="Ready" width="100px">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div class="status-wrapper">
                            <app-status
                                [status]="row.state"
                                [analyzable]="true"
                                [resource]="row"
                                (analyzeFailure)="onAnalyzeFailure($event)"></app-status>
                        </div>
                    </ng-template>
                </app-column>
                <app-column value="labels" header="Labels" width="250px">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div *ngIf="row.labels && (row.labels | keyvalue).length > 0">
                            <app-labels-popover [labels]="row.labels" title="Labels"
                                                [labelTextMapping]="labelTextMapping"
                                                [NO_VALUE_LABEL]="NO_VALUE_LABEL"></app-labels-popover>
                        </div>
                    </ng-template>
                </app-column>
                <app-column header="Annotations" width="250px">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div *ngIf="row.annotations && (row.annotations | keyvalue).length > 0">
                            <app-labels-popover [labels]="row.annotations" title="Annotations"
                                                [labelTextMapping]="annotationTextMapping"
                                                [NO_VALUE_LABEL]="NO_VALUE_LABEL"></app-labels-popover>
                        </div>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" value="modificationTime" width="200px" header="Modified On">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <app-date [date]="row.modificationTime"></app-date>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" value="creationTime" width="200px" header="Created On">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <app-date [date]="row.creationTime"></app-date>
                    </ng-template>
                </app-column>

                <app-column value="apiVersion"
                            header="API Version"></app-column>
                <app-column value="displayName"
                            header="Display Name"></app-column>
                <app-column value="path" header="Path"></app-column>
                <app-column [isSortable]="true" value="name" header="Name" width="500px"></app-column>
            </app-data-table>
        </div>
        <input type="file" #file hidden (change)="handleFileInputChange()"/>
    </ng-template>
    <ng-template #midColumn>
        <app-content-details #contentDetailsComponent
                             (doCloseFcl)="closeFcl()"
                             [localLayout]="localLayout"
                             [resource]="selectedRow"
                             [policiesLoading]="policiesLoading"
                             (editOrganization)="onEditOrganization($event)"
                             (onEditResource)="onEditResource(selectedRow, undefined, $event)"
                             (editWithForm)="onEditWithForm($event)"
                             (delete)="onDeleteResource($event)"
                             (reloadResource)="onReloadResource(selectedRow)"
                             (onReconcileResource)="onReconcileResource($event)"
        ></app-content-details>
    </ng-template>
</fd-flexible-column-layout>
